import { createSlice } from '@reduxjs/toolkit'

export const searchSlice = createSlice({
    name: "search",
    initialState: {
        Query: '',
        Results: [],
        fromSearch: false
    },
    reducers: {
        setQuery: (state, action) => {
            state.Query = action.payload
        },
        setResults: (state, action) => {
            state.Results = action.payload
        },
        setFromSearch: (state) => {
            state.fromSearch = !state.fromSearch
        }
    }
})

export const { setQuery, setResults, setFromSearch } = searchSlice.actions

export default searchSlice.reducer